import React, {Component} from 'react';
import DropdownView from './dropdown-view';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    }
  }

  toggleDropdown = () => this.setState({dropdownOpen: !this.state.dropdownOpen});
  closeDropdown = () => this.setState({dropdownOpen: false});

  onClickOption = (option) => {
    this.props.onClickOption(option);
    this.closeDropdown();
  };

  componentDidMount() {
    window.addEventListener('mousedown', this.anyClick, false);
  }

  anyClick = (e) => {

    if (this.node.contains(e.target)) return; // The click is inside ... continue

    this.closeDropdown();

  };

  render() {
    return (
      <DropdownView
        {...this.props}
        setRef={this.setRef}
        toggleDropdown={this.toggleDropdown}
        closeDropdown={this.closeDropdown}
        dropdownOpen={this.state.dropdownOpen}
        onClickOption={this.onClickOption}
      />
    )
  }

  setRef = (ref) => this.node = ref;

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.anyClick, false);
  }

}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/common/dropdown/dropdown.js